<template lang="pug">
.operation-page
  .title {{title}}
  .content
    slot
  .bottom
    .btn-next(@click="$emit('next')") {{btn}}
  
</template>
<script>
import PrimaryBtn from '@/components/wedgits/PrimaryBtn'
export default {
  name: 'OperationPage',
  components: { PrimaryBtn },
  props: {
    title: {},
    btn: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.operation-page
  +full
  display: flex
  align-items: flex-start
  justify-content: flex-start
  flex-direction: column
  .title
    padding: 0 pxToRem(30)
    font-size: pxToRem(54)
    color: black
  .content
    flex: 1
    width: 100%
  .bottom
    padding: 0 pxToRem(30)
    //flex-shrink: 0
    width: 100%
    height: pxToRem(186)
    //background: blue
    display: flex
    justify-content: center
    align-items: center
    .btn-next
      position: relative
      top: -20%
      width: 100%
      height: pxToRem(98)
      background-image: linear-gradient(135deg, #168BFF 0%, #1664FF 100%)
      box-shadow: pxToRem(2) pxToRem(13) pxToRem(23) pxToRem(-10) rgba(22,139,255,0.60)
      border-radius: pxToRem(8)
      font-size: pxToRem(36)
      line-height: pxToRem(98)
      color: #ffffff
      text-align: center
      .btn-copy
        position: absolute
        left: 5px
        top: -50px
        color: black
        font-size: 14px
</style>
